import { message } from "antd";

const CONF_URL = "https://formapp.adsolucoestecnologia.com.br";

var PATH = '';

export const setPath = (value) => { PATH = value }
export const getPath = () => { return PATH }

export const URL_API = CONF_URL + '/services/php';
export const UPLOAD_API = CONF_URL + '/services/php/upload/upload.php';

export const BLOCK_FORM_ENTER = (e) => {
    if (e.key === "Enter") {
        e.preventDefault();
    }
}

export const getUPLOADAPI = () => {
    return UPLOAD_API + '?path=' + getPath() + '&token=' + getToken();
}

export const titleWeb = (value) => {
    window.document.title = `For+ | ${value}`
}

export const POST_API = (url, data, img = null) => {

    function createFormData() {
        const form = new FormData()

        if (img != null) {
            img?.forEach((item, index) => {
                form.append('file[]', item.originFileObj);
            })
        }

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return form;
    };

    return fetch(URL_API + url, { method: "post", body: createFormData() })

}

export const POST_CATCH = () => {
    message.error('Servidor indisponível')
}

export const POST_API_PAY = (url, data, img = null) => {

    function createFormData() {
        const form = new FormData()

        if (img != null) {
            img?.forEach((item, index) => {
                form.append('file[]', item.originFileObj);
            })
        }

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return form;
    };

    return fetch("https://hellopay.conceitoformaturas.com.br/server/php" + url, { method: "post", body: createFormData() })

}

export const setToken = (value) => {
    localStorage.setItem("TOKEN", value)
}

export const getToken = () => {
    return localStorage.getItem("TOKEN")
}

export const delToken = () => {
    localStorage.removeItem("TOKEN")
}
